<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <v-card>
      <v-form
        ref="form"
        lazy-validation
      >
      <v-tabs v-model="tab">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(item, i) in items" :key="item">
    
    <v-data-table
      :headers="headers"
      :items="i === 0 ? clients : inactive"
      sort-by="Name"
      sort-asc
      class="elevation-1"
      :loading="isLoading"
      loading-text="Loading Clients"
      :search="search"
      height="600"
    >
      <template v-slot:item.select="{ item }">
        <!--<router-link to="/clientInfo">-->
        <router-link
          :to="{
            name: 'ClientInfo',
            params: { clientID: item._id },
          }"
        >
          <v-btn x-small color="#2b3990" class="white--text">
            select
          </v-btn>
        </router-link>
      </template>

      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Clients</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="search"
            label="search"
            class="desktop"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="100%"  :retain-focus="false">
 
            <template v-slot:activator="{ on }" v-if="showButton">
              <v-btn
                color="#2b3990"
                class="mb-2 white--text"
                v-on="on"
                @click="showAdd() "
              >
                <v-icon left>add</v-icon>
                Add Client</v-btn
              >
              <v-btn
                v-if="isAdmin"
                color="success"
                class="mb-2 white--text mr-2"
                @click="download()"
              >
                <v-icon left>mdi-download</v-icon>
                export csv</v-btn
              >

            </template>
            <v-card>
              <v-card-title style="background-color: #2b3990">
                <span class="headline white--text">{{ titleForm }}</span>
              </v-card-title>
              <v-card-text>
                <validation-observer ref="observer">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="3">
                        
                          <v-text-field
                            v-model="newName"
                            label="Client Name"
                            :rules="requiredField"
                          ></v-text-field>
                        
                      </v-col>
                      <v-col cols="12" sm="12" md="3">
                        <v-datetime-picker
                          v-model="newAdmissionDate"
                          :text-field-props="textFieldProps"
                          :time-picker-props="endTimeProps"
                          time-format="hh:mm a"
                          date-format="MM/dd/yyyy"
                          label="Admission Date"
                        ></v-datetime-picker>
                      </v-col>
                      <!-- <v-col cols="12" sm="12" md="6">
                      <v-select
                        label="Service Codes"
                        v-model="newServiceCode"
                        outlined
                        :items="codes"
                        item-value="Code"
                        item-text="Code"
                        multiple
                      ></v-select>
                    </v-col> -->
                      <v-col cols="12" sm="12" md="3">
                       
                          <v-autocomplete
                           v-if="isSuperAdmin"
                            class="d-flex"
                            v-model="newCompany"
                            :items="userCompanies"
                            item-text="Name"
                            item-value="_id"
                            label="Company"
                            multiple
                            :rules="requiredField"
                          ></v-autocomplete>

                          <v-text-field
                            v-else
                            v-model="userCompany"
                            label="Company"
                            :disabled="true"
                          ></v-text-field>
                        
                      </v-col>
                      <v-col cols="12" sm="12" md="3">
                       
                          <v-autocomplete
                            class="d-flex"
                            v-model="newProgram"
                            :items="units"
                            item-text="Name"
                            item-value="Name"
                            label="Program"
                            multiple
                            :rules="requiredField"
                          ></v-autocomplete>
                        
                      </v-col>
                      <v-col cols="12" sm="12">
                        
                          <v-textarea
                            v-model="newBio"
                            outlined
                            label="Client Bio"
                            :rules="requiredField"
                          ></v-textarea>
                        
                      </v-col>
                      <v-col>
                        <v-menu
                          ref="menu3"
                          v-model="menu3"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="newBirthday"
                              label="Birthday"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              clearable
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="newBirthday"
                            @change="calculateAge(newBirthday)"
                            no-title
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        
                          <v-text-field
                            v-model="newAge"
                            label="Age"
                            :rules="requiredField"
                            readonly
                          ></v-text-field>
                        
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        
                          <v-select
                            v-model="newGender"
                            label="Gender"
                            :items="gender"
                            :rules="requiredField"
                          ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        
                          <v-text-field
                            v-model="newEthnicity"
                            label="Ethnicity"
                            :rules="requiredField"
                          ></v-text-field>
                      </v-col>
                      <!-- <v-col cols="12" sm="12" md="6">
                      <v-textarea
                        v-model="newAllergies"
                        label="Allergies"
                        outlined
                      ></v-textarea>
                    </v-col> -->
                      <!-- <v-col cols="12" sm="12" md="6">
                      <v-textarea
                        v-model="newBehaviors"
                        label="Behaviors"
                        outlined
                      ></v-textarea>
                    </v-col> -->
                      <v-col cols="12" sm="12" md="6">
                        
                          <v-text-field
                            v-model="newMedicare"
                            label="Medicare Number"
                            :rules="requiredField"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        
                          <v-text-field
                            v-model="newMedicaid"
                            label="Medicaid Number"
                            :rules="requiredField"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        
                          <v-text-field
                            v-model="newPID"
                            label="PID"
                            :rules="requiredField"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        
                          <v-text-field
                            v-model="newCase"
                            label="Case Number"
                            :rules="requiredField"
                          ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        
                          <v-select
                            v-model="newState"
                            label="State Receving Services In"
                            :items="states"
                            :rules="requiredField"
                          ></v-select>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          label="SSN"
                          v-model="newSSN"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <v-text-field
                          label="Home Address"
                          v-model="newAddress"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="City"
                          v-model="newCity"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="State"
                          v-model="newAddressState"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Zip"
                          v-model="newZip"
                        ></v-text-field>
                      </v-col>

                      <v-col
                        cols="12"
                        sm="12"
                        md="6"
                        v-if="newState == 'Nevada'"
                      >
                        <validation-provider name="Wellsky Number">
                          <v-text-field
                            v-model="newWellsky"
                            label="Wellsky Number"
                          ></v-text-field>
                        </validation-provider>
                      </v-col>

                      <!-- <v-col cols="12" sm="12" md="6">
                        
                          <span>Does the client have adaptive equipment?</span>
                          <v-switch
                            v-model="newAdaptiveEquipment"
                            label="Yes"
                          ></v-switch>
                      </v-col>

                      <v-col cols="12" md="6" v-if="newAdaptiveEquipment">
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="newAdaptiveDate"
                              label="Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="newAdaptiveDate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu.save(date)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col> -->

                      <!-- <v-col cols="12" md="6" v-if="newAdaptiveEquipment">
                        <v-text-field
                          label="Equipment Used"
                          v-model="newEquipmentUsed"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" v-if="newAdaptiveEquipment">
                        <span>Is it used daily?</span>
                        <v-switch
                          label="Yes"
                          v-model="newDailyUse"
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" v-if="!newDailyUse && newAdaptiveEquipment">
                        <v-textarea
                          label="If no, explain how often it's needed"
                          v-model="newExplanation"
                          outlined
                        ></v-textarea>
                      </v-col> -->

                      <v-col cols="12" sm="2">
                        <span>Status</span>
                        <v-switch
                          label="Active"
                          v-model="newStatus"
                          value="Active"
                        ></v-switch>
                        <v-switch
                          label="Inactive"
                          v-model="newStatus"
                          value="Inactive"
                        ></v-switch>
                      </v-col>

                      <v-col cols="12" v-if="newStatus == 'Inactive'">
                          <v-menu
                            ref="menu2"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="newDischargeDate"
                                label="Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="newDischargeDate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu2 = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu2.save(date)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        <v-textarea
                          outlined
                          label="Notes"
                          v-model="newNotes"
                        ></v-textarea>
                      </v-col>

                    </v-row>
                  </v-container>
                </validation-observer>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="white--text"
                  color="#259647"
                  @click="onAddClient(newClient)"
                  v-if="newClient"
                  >Save</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="updateClient()"
                  v-if="editClient"
                  >Update</v-btn
                >
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-text-field
          v-model="search"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          label="search"
          class="mobile ml-5 mr-5 mb-3 mt-3"
        ></v-text-field>
      </template>

      <template v-slot:item.actions="{ item }" class="align-self-center">
        <v-icon small class="mr-2" @click="viewClient(item)">
          mdi-eye
        </v-icon>
        <!-- <v-icon small class="mr-2" @click="editClient(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteClient(item)" v-if="showButton">
          mdi-delete
        </v-icon> -->
        <!-- <v-icon small @click="addDeal(item)">
          add
        </v-icon> -->
      </template>
      <template v-slot:no-data>
        <v-btn color="#2b3990" class="white--text" @click="getSpecificClients()"
          >Reset</v-btn
        >
      </template>
    </v-data-table>
    </v-tab-item>
      </v-tabs-items>
      </v-form>
    </v-card>
    <Foot />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Foot from "../../components/Footer";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";
import {calculateAge} from '../../../helpers/calculateAge'

const url = require("../../client_config/config").url;

export default {
  components: {
    Foot,
    ValidationProvider,
    ValidationObserver,
  },
  data: function() {
    return {
      headers: [
        {
          text: "Select a Client",
          align: "start",
          sortable: false,
          value: "select",
        },
        { text: "Name", value: "Name" },
        { text: "Admission Date", value: "AdmissionDate" },
        { text: "State", value: "State" },
        // { text: "Service Codes", value: "ServiceCode" },
        { text: "Program", value: "Program" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dialog: false,
      tab: null,
      items: ["Active Clients", "Inactive Clients"],
      editClient: false,
      newClient: false,
      msg: false,
      search: "",
      text: "",
      menu3: false,
      menu: false,
      menu2: false,
      clients: [],
      inactive: [],
      units: [],
      codes: [],
      gender: ["Male", "Female"],
      unitID: localStorage.getItem("unitID"),
      userProgram: JSON.parse(localStorage.getItem("userPrograms")),
      userState: localStorage.getItem("userState"),
      userRole: localStorage.getItem("userRole"),
      titleForm: "New Client",
      compID: "",
      clientID: "",
      savedID: "",
      newName: "",
      newAdmissionDate: new Date(),
      newServiceCode: [],
      newProgram: [],
      newBio: "",
      newBirthday: "",
      newAge: "",
      newGender: "",
      newEthnicity: "",
      newAllergies: "",
      newBehaviors: "",
      newMedicare: "",
      newMedicaid: "",
      newPID: "",
      newCase: "",
      newWellsky: "",
      newDiagnoses: "",
      newState: "",
      newAdaptiveEquipment: false,
      newAdaptiveDate: "",
      newEquipmentUsed: "",
      newDailyUse: false,
      newExplanation: "",
      newAddress: "",
      newCity: "",
      newAddressState: "",
      newZip: "",
      newStatus: "",
      newSSN: "",
      newDischargeDate: "",
      newNotes: "",
      states: ["Utah", "Nevada"],
      requiredField: [(v) => !!v || "This is required"],
      editedIndex: -1,
      editedItem: {
        name: "",
        admissionDate: "",
        serviceCode: [],
        program: "",
        bio: "",
        birthday: "",
        gender: "",
        ethnicity: "",
        allergies: "",
        behaviors: "",
        medicare: "",
        medicaid: "",
        pid: "",
        case: "",
        diagnoses: "",
        state: "",
      },
      defaultItem: {
        newName: "",
        admissionDate: "",
        serviceCode: [],
        program: "",
        bio: "",
        birthday: "",
        gender: "",
        ethnicity: "",
        allergies: "",
        behaviors: "",
        medicare: "",
        medicaid: "",
        pid: "",
        case: "",
        diagnoses: "",
        state: "",
      },

      textFieldProps: {
        appendIcon: "event",
      },
      startDateProps: {
        min: moment(new Date()).format("YYYY-MM-DD"),
      },
      startTimeProps: {
        ampmInTitle: true,
      },
      endTimeProps: {
        ampmInTitle: true,
      },

      isLoading: true,
      showButton: false,

      companies: [],
      newCompany: [],
      userCompanies: [],
      userCompany: ""
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
    isAdmin() {
      let roles = [
        "Administration", 
        "Human Resources", 
        "Compliance Manager", 
        "Client Services Manager",
        "Medical Manager",
        "SuperAdministrator"
      ]
      return roles.includes(localStorage.getItem('userRole'))
    },
    isSuperAdmin() {
      let roles = [
        "SuperAdministrator"
      ]
      return roles.includes(localStorage.getItem('userRole'))
    }

  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    // this.getClients();
    this.compID = this.$route.params.compID;
    this.showAction();
    this.getSpecificClients();
    this.getCompanies();
  },

  methods: {
    ...mapActions({
      downloadCSV: "clients/downloadCSV",
    }),

    initialize() {
      this.clients = [];
    },
    validate () {
          return this.$refs.form.validate()
      },
      validateReset(){
      if(this.$refs.form !== undefined){
        this.$refs.form.reset();
      }
    },
    viewClient(item) {
      let Birthday = (item.Birthday == null || item.Birthday == "") ? new Date() : item.Birthday;
      this.titleForm = "Viewing " + item.Name;
      this.dialog = true;
      this.editClient = true;
      this.newClient = false;
      this.newName = item.Name;
      this.newAdmissionDate = new Date(item.AdmissionDate);
      this.newServiceCode = item.ServiceCode;
      this.newProgram = item.Program.split(', ').map(item => item.trim()) || '';
      this.newBio = item.Bio;
      this.newBirthday = moment(Birthday).format("YYYY-MM-DD");
      this.newAge = item.Age;
      this.newGender = item.Gender;
      this.newEthnicity = item.Ethnicity;
      this.newAllergies = item.Allergies;
      this.newBehaviors = item.Behaviors;
      this.newMedicare = item.Medicare;
      this.newMedicaid = item.Medicaid;
      this.newPID = item.PID;
      this.newCase = item.Case;
      this.newWellsky = item.Wellsky;
      this.newDiagnoses = item.Diagnoses;
      this.clientID = item._id;
      this.newState = item.State;
      this.newAdaptiveEquipment = item.AdaptiveEquipment;
      this.newAdaptiveDate = item.AdaptiveDate;
      this.newEquipmentUsed = item.EquipmentUsed;
      this.newDailyUse = item.DailyUse;
      this.newExplanation = item.Explanation;
      this.newAddress = item.Address;
      this.newCity = item.City;
      this.newAddressState = item.AddressState;
      this.newZip = item.Zip;
      this.newStatus = item.Status;
      this.newSSN = item.SSN;
      this.newDischargeDate = item.DischargeDate;
      this.newNotes = item.Notes;
      this.newCompany = item.Company;
      this.calculateAge(this.newBirthday);
    },
    getClientID(item) {
      console.log(item);
      //this.clientID = item._id;
      //window.localStorage.setItem('clientId', this.clientID)
      //localStorage.setItem('clientUnit', this.unitID)
    },
    showAdd() {
      this.titleForm = "New Client";
      this.newClient = true;
      this.editClient = false;
    },

    deleteClient(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this client?") &&
        this.clientDelete(id);
    },

    clientDelete(id) {
      axios.delete(`${url}/clients/${id}`).then((response) => {
        this.getSpecificClients();
        if (response.status == 400) {
          response.json().then(function(data) {
            return data.msg;
          });
        }
        this.msg = true;
        this.text = "The client has been deleted successfully.";
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });

      this.clear();
    },

    updateClient() {
      var req_body = {
        Name: this.newName,
        AdmissionDate: this.newAdmissionDate,
        ServiceCode: this.newServiceCode,
        Program: this.newProgram,
        Bio: this.newBio,
        Birthday: this.newBirthday,
        Age: this.newAge,
        Gender: this.newGender,
        Ethnicity: this.newEthnicity,
        Allergies: this.newAllergies,
        Behaviors: this.newBehaviors,
        Medicare: this.newMedicare,
        Medicaid: this.newMedicaid,
        PID: this.newPID,
        Case: this.newCase,
        Wellsky: this.newWellsky,
        Diagnoses: this.newDiagnoses,
        State: this.newState,
        AdaptiveEquipment: this.newAdaptiveEquipment,
        AdaptiveDate: this.newAdaptiveDate,
        EquipmentUsed: this.newEquipmentUsed,
        DailyUse: this.newDailyUse,
        Explanation: this.newExplanation,
        Address: this.newAddress,
        City: this.newCity,
        AddressState: this.newAddressState,
        Zip: this.newZip,
        Status: this.newStatus,
        SSN: this.newSSN,
        DischargeDate: this.newDischargeDate,
        Notes: this.newNotes,
        // CompanyID: this.compID
        Company: this.newCompany
      };
      axios
        .put(`${url}/clients/${this.clientID}`, req_body)
        .then((response) => {
          // this.getClients();
          if (response.status == 400) {
            response.json().then(function(data) {
              alert(data.msg);
            });
          }
          this.getSpecificClients();
          this.msg = true;
          this.text = "The client has been updated successfully.";
          this.close()
        });
      
    },
    // getClients: function() {
    //   this.isLoading = true;
    //   axios
    //     .get(`${url}/clients`)
    //     .then((res) => {
    //       var temp = res.data.clients
    //       this.clients = []
    //       this.inactive = []
    //       for (var i = 0; i < temp.length; i++) {
    //         var dt = new Date(temp[i].AdmissionDate);
    //         temp[i].AdmissionDate = moment(dt).format(
    //           "MM-DD-YYYY hh:mm a"
    //         );
    //       }
    //       this.getUnits();
    //       this.getCodes();
    //     })
    //     .finally(() => (this.isLoading = false));
    // },

    getUnits: function() {
      axios.get(`${url}/units`).then(async (res) => {
        this.units = res.data.units;
      });
    },
    getCodes: function() {
      axios.get(`${url}/codes`).then(async (res) => {
        this.codes = res.data.codes;
      });
    },

    getCompanies: function () {
        this.isLoading = true;
        axios.get(`${url}/companies`).then(res => {
            this.companies = res.data.companies;

            const companyIds = localStorage.getItem('userCompanies');
          
            this.userCompanies = this.userRole === 'SuperAdministrator'
              ? this.companies
              : this.companies
                  .filter(company => companyIds.includes(company._id))
                  .map(company => company.Name);

            this.userCompany = this.userCompanies

        }).finally(() => this.isLoading = false);
    },

    async onAddClient(context) {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        context ? this.addClient() : this.updateClient();
        this.clear();
        return;
      } else {
        this.msg = true
        this.text = "Please fill out all required fields"
      }
    },

    addClient: function() {
      var req_body = {
        Name: this.newName,
        AdmissionDate: this.newAdmissionDate,
        ServiceCode: this.newServiceCode,
        Program: this.newProgram,
        Bio: this.newBio,
        Birthday: this.newBirthday,
        Age: this.newAge,
        Gender: this.newGender,
        Ethnicity: this.newEthnicity,
        Allergies: this.newAllergies,
        Behaviors: this.newBehaviors,
        Medicare: this.newMedicare,
        Medicaid: this.newMedicaid,
        PID: this.newPID,
        Case: this.newCase,
        Wellsky: this.newWellsky,
        Diagnoses: this.newDiagnoses,
        State: this.newState,
        AdaptiveEquipment: this.newAdaptiveEquipment,
        AdaptiveDate: this.newAdaptiveDate,
        EquipmentUsed: this.newEquipmentUsed,
        DailyUse: this.newDailyUse,
        Explanation: this.newExplanation,
        Address: this.newAddress,
        City: this.newCity,
        AddressState: this.newAddressState,
        Zip: this.newZip,
        Status: this.newStatus,
        SSN: this.newSSN,
        DischargeDate: this.newDischargeDate,
        Notes: this.newNotes,
        // CompanyID: this.compID
        Company: this.newCompany
      };

      axios.post(`${url}/clients`, req_body).then((res) => {
        // this.getClients();
        this.getSpecificClients();
        if (res.status == 400) {
          res.json().then(function(data) {
            this.text = data.msg;
          });
        }
        this.msg = true;
        this.text = "The new client has been added successfully.";
      });
      this.isLoading = true;
      this.close();
    },

    async getSpecificClients() {
      this.isLoading = true
      console.log("getting clients data")
      this.getUnits()
      this.getCodes()

      let endpoint = `${url}/clients`
      let params = {}
      
      const companyIds = localStorage.getItem('userCompanies')
      
      if(this.userRole !== 'SuperAdministrator'){
        // If not SuperAdmin, filter fetched data based on the user's Company
        params['Company:in'] = JSON.parse(companyIds)
        
        if(this.isAdmin){  
          // If user belongs to Admin group but its user role is not Administration,
          // filter fetched data based on the user's State
          if(this.userRole !== 'Administration'){
              params['State'] = this.userState
          }
        }else{
          // If the user does not belong to Admin group, filter fetched data based on
          // the user's Program and State
          let userProgram =  this.userProgram.filter(program => program != "")
          params['Program:in'] = userProgram
          params['State'] = this.userState
        }
      
      }

      try {
        const res = await axios.get(endpoint, { params });
        const temp = res.data.clients;
        this.clients = [];
        this.inactive = [];

        temp.forEach(client => {
          const formattedDate = client.AdmissionDate
            ? moment(new Date(client.AdmissionDate)).format("ddd, LLL")
            : "";
            
          if (Array.isArray(client.Program)) {
            client.Program = client.Program
              .map(program => program.trim())
              .join(', ');
          }

          client.AdmissionDate = formattedDate;

          if (client.Status === 'Inactive') {
            this.inactive.push(client);
          } else {
            this.clients.push(client);
          }
        });

      } catch (error) {
        console.error("Error fetching clients:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async download(){
      try {
        const response = await this.downloadCSV()
        if(response.success){
            var FileSaver = require("file-saver");
            const blob = new Blob([response.data], { type: "text/csv" });
            FileSaver.saveAs(blob, response.filename);
            return
        }
        this.msg = true;
        this.text = response.message
      } catch (error) {
        console.log(error)
        this.msg = true;
        this.text = "An Error Occured"
      } 
    },

    clear() {
      this.newName = "";
      this.newAdmissionDate = "";
      this.newServiceCode = [];
      this.newProgram = [];
      this.newBio = "";
      this.newBirthday = "";
      this.newAge = "";
      this.newGender = "";
      this.newEthnicity = "";
      this.newAllergies = "";
      this.newBehaviors = "";
      this.newMedicare = "";
      this.newMedicaid = "";
      this.newPID = "";
      this.newCase = "";
      this.newWellsky = "";
      this.newDiagnoses = "";
      this.newState = "";
      this.newAdaptiveEquipment = false;
      this.newAdaptiveDate = "";
      this.newEquipmentUsed = "";
      this.newDailyUse = false;
      this.newExplanation = "";
      this.newAddress = "";
      this.newCity = "";
      this.newAddressState = "";
      this.newZip = "";
      this.newStatus = "";
      this.newSSN = "";
      this.newDischargeDate = "";
      this.newNotes = "";

      this.$refs.observer[0].reset();
    },

    showAction() {
      if (
        this.userRole == "Program Coordinator" ||
        this.userRole == "Client Services Manager" ||
        this.userRole == "Administration" ||
        this.userRole == "Human Resources" ||
        this.userRole == "Compliance Manager" ||
        this.userRole == "SuperAdministrator" 

      ) {
        this.showButton = true;
      }
    },

    calculateAge(date){
      this.newAge = calculateAge(date)
    }
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}
</style>
